// Set actions for table clicks
// Visit url or load remote dataa on row click
export default function(tableId) {

  // Set table
  let table = $('#' + tableId)

  // Set actions for clicking on a row
  const tableRowClickAction = function(row) {

    // Do not take action if row has 'no-click' class
    if ( !row.hasClass('no-click') && !row.find('td').hasClass('dataTables_empty') ) {

      // Get request url from table data attribute
      let url = row.closest('.table').attr('data-request-url');

      if (typeof url !== 'undefined') {

        // Replace url framework id with data from row
        if (url.includes(":framework_id")) {
          let frameworkId = row.attr('data-framework-id');
          url = url.replace(':framework_id', frameworkId);
        } 

        // Replace issuer_id with data from row
        if (url.includes(":issuer_id")) {
          let issuerId = row.attr('data-issuer-id');
          url = url.replace(':issuer_id', issuerId);
        } else if (url.includes("issuer_id")) {
          let issuerId = row.attr('data-issuer-id');
          url = url.replace('issuer_id', issuerId);
        } 

        // Replace url methodology id with data from row
        if (url.includes(":methodology_id")) {
          let methodologyId = row.attr('data-methodology-id');
          url = url.replace(':methodology_id', methodologyId);
        } else if (url.includes("=methodology_id")) {
          let methodologyId = row.attr('data-methodology-id');
          if (methodologyId === null) {return;}
          url = url.replace('=methodology_id', '=' + methodologyId);
        } 

        // Replace url slug (featured topic) with data from row
        if (url.includes(":slug")) {
          let slug = row.attr('data-slug');
          url = url.replace(':slug', slug);
        } 

        // Replace url record id with data from row
        if (url.includes(":record_id")) {
          let recordId = row.attr('data-record-id');
          if (recordId === null) {return;}
          url = url.replace(':record_id', recordId);
        } else if (url.includes("record_id")) {
          let recordId = row.attr('data-record-id');
          if (recordId === null) {return;}
          url = url.replace('record_id', recordId);
        }

        // Replace url record type with data from row
        if (url.includes(":record_type")) {
          let recordType = row.attr('data-record-type');
          url = url.replace(':record_type', recordType);
        }

        // Replace url token with data from row
        if (url.includes(":token")) {
          let token = row.attr('data-record-token');
          url = url.replace(':token', token);
        }

        // Only continue if url does not include any 'template' strings
        let templateStrings = [":framework_id", ":record_id"];
        let i;
        for (i=0;i<templateStrings.length;i++) {
          if (url.indexOf(templateStrings[i]) !== -1) {
            return;
          }
        }

        if (table.hasClass('remote-links')) {
          return $.get(url)
        } else if (table.hasClass('turbo-links')) {

          // Use fetch with turbo-stream headers instead of Turbo.visit for stream responses
          return fetch(url, {
            method: 'GET',
            headers: {
              'Accept': 'text/vnd.turbo-stream.html, text/html, application/xhtml+xml',
              'X-Requested-With': 'XMLHttpRequest'
            }
          }).then(response => {
            if (response.ok) {
              return response.text().then(html => {
                if (response.headers.get('content-type')?.includes('turbo-stream')) {
                  // Process turbo stream response
                  Turbo.renderStreamMessage(html)
                } else {
                  // Fallback to regular navigation for HTML responses
                  Turbo.visit(url)
                }
              })
            }
          })

        } else if (table.hasClass('target-blank')) {
          return window.open(url)
        } else if (table.hasClass('full-page-links')) {
          window.location.assign(url) // Prevents CORS issues with Turbo.visit, allows opening in same tab
          return null;
        } else {
          return Turbo.visit(url, { acceptsStreamResponse: true })
        }

      }

    }
  };

  // Set click areas
  // Need to avoid triggering action when clicking a checkbox -- used for chart tables to 
  // interact with charts
  let firstTd;
  firstTd = 'tbody > tr > td:first-child';
  let checkBox = 'tbody > tr > td:first-child .checkbox';
  let hasCheckbox = $('th.checkbox-cell').length;
  if (hasCheckbox === 0) {
    $(table).on('click', firstTd, function() { return tableRowClickAction($(this).closest('tr')); });
  }

  // On click of action arrow on right side of row
  let actionVisit = 'tbody > tr > td:last-child > .action-visit';
  $(table).on('click', actionVisit, function() { tableRowClickAction($(this).closest('tr')); });

  const otherTds = 'tbody > tr > td:not(:first-child):not(:last-child)';
  return $(table).on('click', otherTds, function() { tableRowClickAction($(this).closest('tr')); });

};

